/**
 * Halomora — Feature flags.
 *
 * Documentazione completa:
 *   docs/operational_docs/stripe-payments-legal-readiness-runbook.md
 *
 * SUBSCRIPTIONS_ENABLED
 * ---------------------
 * Controlla la possibilità per le aziende di sottoscrivere i piani B2B
 * ricorrenti (PRO / SCALE / ULTRA) tramite Stripe.
 *
 *   false  →  FASE 1 (no Partita IVA).
 *             - UI subscription nascosta su /for-businesses e /company/dashboard.
 *             - Endpoint server (api/ops:b2b_subscription_checkout / b2b_billing_portal)
 *               restituiscono 503.
 *             - Booking marketplace e Stripe Connect vendor restano ATTIVI.
 *
 *   true   →  FASE 2 (con Partita IVA).
 *             - UI subscription ripristinata, checkout Stripe live.
 *             - Richiede anche env var SUBSCRIPTIONS_ENABLED=true su Vercel
 *               per riattivare gli endpoint server.
 *
 * Per riattivare in Fase 2:
 *   1. Cambiare la costante qui sotto in `true`.
 *   2. Impostare `SUBSCRIPTIONS_ENABLED=true` nelle env di produzione.
 *   3. Verificare che `Price ID` PRO e SCALE live siano configurati.
 *   4. Verificare che il `Customer Portal` Stripe sia attivo in live.
 */
export const SUBSCRIPTIONS_ENABLED = false;
